export default __webpack_public_path__ + "c18294314a3763b4e41eafa7144d5762.jpg";